import React from "react";

const badge = "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border";

export function freightSocialMediaActiveCell(row) {
  const on = String(row?.status) === "1";
  return (
    <span className={`${badge} ${on ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-gray-200 bg-gray-50 text-gray-600"}`}>
      {on ? "Active" : "Inactive"}
    </span>
  );
}

export function freightSocialMediaIconCell(row) {
  const url = row?.icon_url != null ? String(row.icon_url).trim() : "";
  if (!url) {
    return <span className="text-gray-400 text-xs">{row?.icon ? String(row.icon) : "—"}</span>;
  }
  return (
    <img
      src={url}
      alt=""
      className="h-10 w-10 rounded-md border border-gray-200 object-contain bg-white"
      loading="lazy"
    />
  );
}

export function freightSocialMediaLinkCell(row) {
  const href = row?.link != null ? String(row.link).trim() : "";
  if (!href) return <span className="text-gray-400">—</span>;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-sm text-[#064E8D] underline break-all max-w-xs inline-block">
      {href}
    </a>
  );
}

export const FREIGHT_SOCIAL_MEDIA_COLUMNS = [
  { key: "id", label: "ID", aliases: [], defaultVisible: false },
  { key: "name", label: "Name", aliases: [], defaultVisible: true },
  {
    key: "icon_url",
    label: "Icon",
    aliases: ["icon"],
    defaultVisible: true,
    sortable: false,
    renderCell: freightSocialMediaIconCell
  },
  {
    key: "link",
    label: "Link",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightSocialMediaLinkCell
  },
  { key: "order_no", label: "Order", aliases: ["orderNo"], defaultVisible: true },
  {
    key: "status",
    label: "Status",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightSocialMediaActiveCell
  }
];
